import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

export const IMG_URL = (path) => path ? `${BASE}/api/products/image/${path}` : null;
// Liste/kart görünümleri için küçük önizleme (yoksa backend orijinali döner)
export const THUMB_URL = (path) => path ? `${BASE}/api/products/image/${path}?thumb=1` : null;

export function extractError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Bir hata oluştu";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export const formatTL = (n) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(v);
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  try { return new Date(iso).toLocaleString("tr-TR"); } catch { return iso; }
};
